const ENUM_DISPLAY_COMPONENT = Object.freeze( {
  SIGNIN: 1,
  GET_CODE: 2,
  VERIFY_CODE: 3,
  CHANGE_PWD: 4
} );

export default ENUM_DISPLAY_COMPONENT;